import { FC } from 'react';
import Highlighter, { HighlighterProps } from 'react-highlight-words';

export const TextHighlighter: FC<HighlighterProps> = (props) => <Highlighter autoEscape {...props} />;
